var _defs, _path, _path2, _g, _g2, _g3, _path3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.84 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .d {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m9.76,8.22c.2-1.16,0-2.42-.66-3.39s-1.83-1.63-3.01-1.54c-1.33.1-2.47,1.09-3.05,2.29s-.7,2.57-.69,3.9c.01,1.49.16,2.98.46,4.44.1.48.21.97.45,1.4.69,1.24,2.38,1.73,3.7,1.21s2.19-1.91,2.27-3.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m23.99,7.83c0-1.38-.43-2.82-1.46-3.74s-2.71-1.17-3.81-.33c-1.15.87-1.34,2.49-1.43,3.93-.07,1.13-.15,2.26-.22,3.39-.08,1.26-.16,2.58.33,3.75s1.71,2.14,2.96,1.88c.79-.16,1.42-.77,1.91-1.41,1.58-2.06,1.7-4.75,1.72-7.47Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m31.72,17.21c.27-4.54.27-9.1,0-13.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m38.85,17.11V2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m38.75,17.18c-2.38-4.64-3.64-9.81-6.15-14.39"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m49.25,17.29c.09-4.86.03-9.73-.18-14.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m44.8,3.18c2.61-.55,5.32-.61,7.95-.18"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m59.06,17.11c.79-4.41,1.39-8.84,1.8-13.3.82-.49,1.75-.81,2.7-.93.38,4.7,1.23,9.37,2.54,13.9-.01-.16-.03-.32-.04-.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m60.83,10.61l2.45-.82c.08-.03.18-.05.23.02s-.1.16-.1.08"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m79.27,6.54c.22-1.23-.47-2.56-1.61-3.08s-2.6-.17-3.38.8c-.61.76-.79,1.78-.92,2.75-.29,2.25-.39,4.53-.32,6.8.03.92.14,1.94.85,2.53.66.55,1.64.53,2.44.22,1.42-.55,2.47-1.93,2.62-3.45"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m89.43,17.29c.4-4.85.38-9.74-.06-14.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m84.83,3.24c2.84-.36,5.71-.51,8.58-.46"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.7905657f16d8f0028d943df9cfa873ae.svg";
export { ForwardRef as ReactComponent };